export const locale = {
    lang: 'en',
    data: {
        ORDER_CLINIC_MESSAGE: {
            TITLE: 'Chat',
            EMPTY: 'No messages',
            ORDER_FINISHED: 'Order finished',
            ERROR_USER_LOGGED_EQUAL_CUSTOMER: 'You are not allowed to send messages to yourself',
            FORM: {
                FIELDS: {
                    MESSAGE: 'Type your message',
                },
            },
            MAT_MENU: {
                FILES: 'Files',
                PHOTOS_AND_VIDEOS: 'Photos and videos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'Only images or videos are allowed.',
                    FILE: 'Only files other than images or videos are allowed.',
                    MAX_FILE: 'A maximum of 15 files are allowed.',
                    MAX_FILE_SIZE: 'Files larger than 150 MB are not allowed.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Send',
                        CANCEL: 'Cancel',
                    },
                },
                PREVIEW: {
                    TITLE: 'Preview',
                },
                IMAGE: {
                    TITLE: 'View image',
                },
            },
            DROPZONE: {
                DESCRIPTION: 'Drop files to upload',
            },
        },
    },
};
